import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router";
import { ConfigProvider } from "./context/ConfigContext";
import { ServiceProvider } from "./providers/ServiceProvider";
import { ShareViewOptionsProvider } from "./contexts/ShareViewOptionsContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import React from 'react';
import type { TrackingParams } from './types/tracking';
import { DeploymentStatusBox } from '@sofatutor/common/components';

const queryClient = new QueryClient();

type AppProps = {
  basename?: string;
  trackingParams?: TrackingParams;
  isRails?: boolean;
};

const App: React.FC<AppProps> = ({ basename = '/', trackingParams, isRails = false }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ConfigProvider>
          <ShareViewOptionsProvider>
            <ServiceProvider>
              <Sonner />
              <BrowserRouter basename={basename}>
                <Routes>
                  <Route path="/" element={<Index trackingParams={trackingParams} />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
              {!isRails && React.createElement(DeploymentStatusBox as React.ComponentType)}
            </ServiceProvider>
          </ShareViewOptionsProvider>
        </ConfigProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
